import { Select } from "antd";
import FormItem from "antd/es/form/FormItem";
import { ReactNode, useMemo } from "react";

type Props = {
  isDisabled?: boolean;
  isLoading: boolean;
  isRequired?: boolean;
  label?: ReactNode;
  multiple?: boolean;
  locations: {
    id: string;
    name: string;
    idNumber: number;
  }[];
};

export function LocationSelectorComponent(props: Props) {
  const options =
    useMemo(() => {
      return props.locations.map((location) => ({
        label: `${location.idNumber} - ${location.name}`,
        value: location.id,
      }));
    }, [props.locations]) || [];

  return (
    <FormItem
      name={props.multiple ? "locationIds" : "locationId"}
      label={props.label || "大樓"}
      rules={[{ required: props.isRequired, message: "請選擇大樓" }]}
    >
      <Select
        disabled={props.isDisabled}
        loading={props.isLoading}
        mode={props.multiple ? "multiple" : undefined}
        optionFilterProp='label'
        options={options}
        placeholder='請選擇大樓'
        showSearch
      />
    </FormItem>
  );
}
